export default __webpack_public_path__ + "static/media/DSC_7473.8718a2c2.jpg";